module.exports = __webpack_public_path__ + "static/img/ic_zoom_off.1784115679763.png";